import {
  ApiResponse,
  ProfileResponseDataV2,
  UpdatePhoneResponseData,
} from '../models/apiResponse';
import { apiRequests as requests } from './http-client';

const ProfileV2 = {
  profile: () =>
    requests
      .get<ApiResponse<ProfileResponseDataV2>>('/v2/profile')
      .then((authResponse) => ({
        user: authResponse.data?.user,
        gup: authResponse.data?.gup,
      })),
  deleteProfile: () => requests.del<ApiResponse>('/v2/profile'),
  updatePassword: (password: string, old_password?: string) =>
    requests
      .post<ApiResponse<ProfileResponseDataV2>>('/v2/profile/update-password', {
        password,
        confirm_password: password,
        old_password,
      })
      .then((authResponse) => ({
        user: authResponse.data?.user,
        gup: authResponse.data?.gup,
      })),
  updatePhone: (phone: string, phoneCountryCode: string) =>
    requests
      .post<ApiResponse<UpdatePhoneResponseData>>('/v2/profile/update-phone', {
        phone_country_code: phoneCountryCode,
        phone,
      })
      .then((response) => response),
  verifyPhone: (phoneCountryCode: string, phoneNumber: string, code: string) =>
    requests
      .post<ApiResponse>('/v2/profile/verify-phone', {
        phone_country_code: phoneCountryCode,
        phone: phoneNumber,
        code,
      })
      .then((authResponse) => authResponse.data),
};

export default ProfileV2;
